/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';
    /**
     * Factory callback type
     */
    declare type PipeDirectiveFactoryCb = ($interval: angular.IIntervalService,
                                           modalService: ngModal.IModalService, 
                                           connectionRoomService: Services.ConnectionRoomService,
                                           $timeout: angular.ITimeoutService,
                                           videoFeedService: Services.VideoFeedService,
                                           messageTranslationsService: Services.MessageTranslationsService,
                                           userService: Services.UserService) => PipeDirective;

    /**
     * Custom scope
     */
    export interface IPipeScopeDef {
        model: string;
        change: string;
        playPause: string;
        source: string;
        destination: string;
        setDestination: string;
        setSource: string;
        disconnectDestination: string;
        disconnectSource: string;
    }


    /**
     * Custom scope
     */
    export interface IPipeScope extends ng.IScope {
        THUMBNAIL_FAIL_IMG: string;
        model: Models.IPipe;        
        addDestination: () => void;
        delDestination: (index: number) => void;
        delSource: () => void;
        searchSource: () => void;
        /** @deprecated Play stream functionality is deprecated temporarily for performance reasons */
        showSourceVideoPrompt: () => void;
        /** @deprecated Play stream functionality is deprecated temporarily for performance reasons */
        showDestVideoPrompt: (index: number) => void;
        /** @deprecated Play stream functionality is deprecated temporarily for performance reasons */
        showVideoPrompt: (blockId: string, videoFeed: Models.IVideoFeed) => void;
        /** @deprecated Play stream functionality is deprecated temporarily for performance reasons */
        showVideo: (blockId: string, videoFeed: Models.IVideoFeed) => void;
        searchDestination: (index: number) => void;
        changePipeStatus: (index: number) => void;
        change: () => void;
        playPause: (args: IPlayPauseArgs) => void;
        source: () => ng.IPromise<Models.Block>;
        destination: () => ng.IPromise<Models.Block>;
        // set-source="crc.addSource(pipe, source)"
        // set-destination="crc.addDestination(pipe, destination, index)"
        setDestination: (args: Object) => void;
        setSource: (args: Object) => void;
        disconnectDestination: () => ng.IPromise<Models.IPipe>; 
        disconnectSource: () => ng.IPromise<Models.IPipe>;
        disconnectSourceModal: () => void;
        disconnectDestinationModal: (index: number) => void;
        loadVideoFeed: (initial?: boolean) => void;
        loadThumbnails: () => void;
        delayedLoadVideoFeed: () => void;
        thumbnailTimer: angular.IPromise<void>;
        videofeedTimer: angular.IPromise<void>;
        sourceThumbnail: string;
        destThumbnails: string[];
        allowStreamPlay: boolean;
    }

    interface IPlayPauseArgs {
        pipe: Models.IPipe;
        index: number;
    }

    export class PipeDirective implements ng.IDirective {
        public static $name: string = "pipe";
        private static THUMBNAIL_LOADING_IMG: string = "images/thumbnail-loading.png";
        private static THUMBNAIL_FAIL_IMG: string = "images/thumbnail-fail.png";
        private static LOAD_VIDEOFEED_DELAY: number = 1000;

        public link: (scope: IPipeScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/pipe-directive.html';
        public scope: IPipeScopeDef = {
            model: '=',
            change: '&',        // save changes method
            playPause: '&',     // play / pause method
            source: '&',        // search source method
            destination: '&',   // search destination method
            setDestination: '&',
            setSource: '&',
            disconnectDestination: '&',    // disconnect destination
            disconnectSource: '&',    // disconnect sources            
        };

        private modalService: ngModal.IModalService;
        private THUMBNAIL_TIMER_MS: number = 4000;
        private VIDEOFEED_TIMER_MS: number = 5000;

        /**
         * Factory for the directive
         */
        public static Factory(): PipeDirectiveFactoryCb {
            let directive: PipeDirectiveFactoryCb = ($interval: angular.IIntervalService, 
                                                     modalService: ngModal.IModalService, 
                                                     connectionRoomService: Services.ConnectionRoomService,
                                                     $timeout: angular.ITimeoutService,
                                                     videoFeedService: Services.VideoFeedService,
                                                     messageTranslationsService: Services.MessageTranslationsService,
                                                     userService: Services.UserService) => {
                return new PipeDirective($interval,
                                         modalService,
                                         connectionRoomService,
                                         $timeout,
                                         videoFeedService,
                                         messageTranslationsService,
                                         userService);
            };
            directive.$inject = ['$interval',
                                 'ModalService',
                                 'connectionRoomService',
                                 '$timeout',
                                 'videoFeedService',
                                 'messageTranslationsService',
                                 'userService',
                                ];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($interval: angular.IIntervalService,
                    modalService: ngModal.IModalService,
                    connectionRoomService: Services.ConnectionRoomService,
                    $timeout: angular.ITimeoutService,
                    videoFeedService: Services.VideoFeedService,
                    messageTranslationsService: Services.MessageTranslationsService,
                    userService: Services.UserService, ) {
            this.modalService = modalService;
            
            PipeDirective.prototype.link = (scope: IPipeScope, element: JQuery, attrs: ng.IAttributes) => {
                scope.model.sourceVideoFeed = Models.VideoFeed.Empty();
                scope.model.destinationVideoFeed = [];
                scope.THUMBNAIL_FAIL_IMG = PipeDirective.THUMBNAIL_FAIL_IMG;
                scope.destThumbnails = [];

                if (scope.model.source !== '')
                    scope.sourceThumbnail = PipeDirective.THUMBNAIL_LOADING_IMG;

                for (let x: number = 0; x < scope.model.destinations.length; x++) {
                    if (!scope.model.destinations[x].empty && scope.model.destinations[x].destination) {
                        scope.destThumbnails[x] = PipeDirective.THUMBNAIL_LOADING_IMG;
                    }
                }    

                scope.addDestination = function(): void {
                    scope.model.destinations.push({ name: undefined, destination: '', status: false, 
                                                    streamPipeHref: undefined, empty: true, locked: false});
                    scope.change();
                    scope.delayedLoadVideoFeed();
                };

                scope.disconnectSourceModal = () => {
                    let isPlaying: boolean = false, 
                        len: number = scope.model.destinations.length,
                        i: number = 0;
                    
                    while (i < len && !isPlaying) {
                        if (scope.model.destinations[i].status)
                            isPlaying = true;
                        i++; 
                    }
                    modalService.showModal({
                        templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                        controller: Application.Controllers.ConfirmModalController.$name,
                        inputs: {
                            title: 'DISCONNECT SOURCE',
                            description: isPlaying ? "Video transmission will stop for all destinations. Are you sure?"
                                                   : "This action will not stop any video transmission",
                            name: '',
                            type: 'warning',
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                            {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();
                        modal.close.then((result: string) => {
                            modalElem.hide();
                            if (result) {
                                scope.delSource();
                            }
                        });
                    });
                };

                scope.disconnectDestinationModal = (index: number) => {
                    let hasBlockDefined: boolean = scope.model.destinations[index].destination !== '';
                    if (hasBlockDefined) {
                        let isPlaying: boolean = scope.model.destinations[index].status; 
                        modalService.showModal({
                            templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                            controller: Application.Controllers.ConfirmModalController.$name,
                            inputs: {
                                title: 'DISCONNECT DESTINATION',
                                description: isPlaying ? "ATTENTION: Video transmission will stop for this destination. Are you sure?"
                                                    : "This action will not stop any video transmission",
                                name: '',
                                type: 'warning',
                            },
                        }).then((modal: ngModal.IModalObject) => {
                            let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                                {bgclose: false, modal: false, keyboard: false});
                            modalElem.show();
                            modal.close.then((result: string) => {
                                modalElem.hide();
                                if (result)
                                    scope.delDestination(index);
                            });
                        });
                    } else {
                        scope.delDestination(index);
                    }
                };

                scope.delSource = (): void => {
                    if (this.containsLockedDestinations(scope.model.destinations)) {
                        this.showLockedSourceModal();
                        return;
                    }

                    if (scope.model.source !== '') {
                        scope.model.source = '';
                        scope.model.sourceName = '';
                        scope.model.destinations.forEach((destination: Models.IDestination) => {
                            destination.status = false;
                        });
                        scope.disconnectSource();
                    }
                    
                    scope.delayedLoadVideoFeed();
                };

                scope.delDestination = async (index: number): Promise<void> => {
                    if (scope.model.destinations[index].locked) {
                        this.showLockedDestinationModal(); 
                    } else {
                        if (scope.model.destinations[index].destination !== '') {
                            scope.model.destinations[index].destination = '';
                            scope.model.destinations[index].name = '';
                            scope.model.destinations[index].status = false;
                            scope.model.disconnectedDestination = index;
                            await scope.disconnectDestination();
                        }
                        scope.model.destinations.splice(index, 1);
                        scope.destThumbnails.splice(index, 1);

                        scope.change();
                        scope.delayedLoadVideoFeed();

                    }
                };

                scope.searchSource = function(): void {
                    scope.source()
                         .then((result: Models.Block) => {
                             scope.model.source = result.href.substr(result.href.lastIndexOf('/') + 1);
                             scope.sourceThumbnail = PipeDirective.THUMBNAIL_LOADING_IMG;                             
                             scope.setSource({pipe: scope.model, source: scope.model.source});
                             scope.delayedLoadVideoFeed();
                         })
                         .catch((reason: ngCustom.IReason) => {
                             messageTranslationsService.showPromiseError(reason);
                         });
                };

                scope.searchDestination = function(index: number): void {
                    scope.destination()
                         .then((result: Models.Block) => {
                             let destinationBlockId: string = result.href.substr(result.href.lastIndexOf('/') + 1);
                             scope.model.destinations[index].destination = destinationBlockId;
                             scope.destThumbnails[index] = PipeDirective.THUMBNAIL_LOADING_IMG;
                             scope.setDestination({
                                 pipe: scope.model, 
                                 destination: destinationBlockId, 
                                 index: index,
                             });
                             scope.delayedLoadVideoFeed();
                         })
                         .catch((reason: ngCustom.IReason) => {
                             messageTranslationsService.showPromiseError(reason);
                         });
                };
                
                scope.changePipeStatus = (index: number): void => {
                    if (scope.model.destinations[index].locked) {
                        this.showLockedDestinationModal();
                    } else {
                        if (scope.model.destinations[index].destination !== '' &&
                            scope.model.source !== '') {
                            scope.model.destinations[index].status = !scope.model.destinations[index].status;
                            scope.playPause({pipe: scope.model, index: index});
                            scope.delayedLoadVideoFeed();
                        }
                    }
                };

                scope.loadVideoFeed = (initial?: boolean): void => {
                    if (scope.model !== undefined) {
                        if (scope.model.source !== "") {
                            if (initial) {
                                // initial loading: get video feed and thumbnails as soon as possible
                                connectionRoomService.getVideoFeedByBlockIdNoList(scope.model.source, (videoFeed: Models.VideoFeed) => {
                                    if (videoFeed.status !== Models.VideoFeedStatus.ERROR && 
                                        !videoFeed.equals(scope.model.sourceVideoFeed)) {
                                        scope.model.sourceVideoFeed = videoFeed;
                                        scope.loadThumbnails();
                                    }
                                });
                            } else {
                                connectionRoomService.getVideoFeedByBlockId(scope.model.source, (videoFeed: Models.VideoFeed) => {
                                    if (videoFeed.status !== Models.VideoFeedStatus.ERROR && 
                                        !videoFeed.equals(scope.model.sourceVideoFeed)) {
                                        scope.model.sourceVideoFeed = videoFeed;
                                    }
                                });
                            }
                        }

                        for (let x: number = 0; x < scope.model.destinations.length; x++) {
                            if (!scope.model.destinations[x].empty && scope.model.destinations[x].destination) {
                                if (initial) {
                                    // initial loading: get video feed and thumbnails as soon as possible
                                    connectionRoomService.getVideoFeedByBlockIdNoList(scope.model.destinations[x].destination, 
                                        (videoFeed: Models.VideoFeed) => {
                                        if (videoFeed.status !== Models.VideoFeedStatus.ERROR && 
                                            !videoFeed.equals(scope.model.destinationVideoFeed[x])) {
                                            scope.model.destinationVideoFeed[x] = videoFeed;
                                            scope.loadThumbnails();
                                        }
                                    });
                                } else {
                                    connectionRoomService.getVideoFeedByBlockId(scope.model.destinations[x].destination, 
                                        (videoFeed: Models.VideoFeed) => {
                                        if (videoFeed.status !== Models.VideoFeedStatus.ERROR && 
                                            !videoFeed.equals(scope.model.destinationVideoFeed[x])) {
                                            scope.model.destinationVideoFeed[x] = videoFeed;
                                        }
                                    });
                                }
                            }
                        }
                    }
                };

                scope.delayedLoadVideoFeed = (): void => {
                    $timeout(() =>  {
                        scope.loadVideoFeed();
                    }, PipeDirective.LOAD_VIDEOFEED_DELAY);
                };

                scope.thumbnailTimer = $interval(() => {
                    scope.loadThumbnails();
                }, this.THUMBNAIL_TIMER_MS + Common.Utils.randomNumber(1000));

                scope.loadThumbnails = () => {
                    // reloads the thumbnail, if available, with a new timestamp
                    if (scope.model.sourceVideoFeed.status !== Models.VideoFeedStatus.ERROR) {
                        if (scope.model.sourceVideoFeed.thumbnailUrl !== "") {
                            if (scope.model.sourceVideoFeed.forceRefreshThumbnail)
                                scope.sourceThumbnail = scope.model.sourceVideoFeed.thumbnailUrl + "?&" + 
                                                        Common.Utils.getCurrentTimestamp();
                            else
                                scope.sourceThumbnail = scope.model.sourceVideoFeed.thumbnailUrl;
                        }
                        else
                            scope.sourceThumbnail = PipeDirective.THUMBNAIL_FAIL_IMG;
                    }

                    for (let x: number = 0; x < scope.model.destinations.length; x++) {
                        if (!scope.model.destinations[x].empty && scope.model.destinationVideoFeed[x]) {
                            if (scope.model.destinationVideoFeed[x].thumbnailUrl !== "") {
                                if (scope.model.destinationVideoFeed[x].forceRefreshThumbnail)
                                    scope.destThumbnails[x] = scope.model.destinationVideoFeed[x].thumbnailUrl + "?&" + 
                                        Common.Utils.getCurrentTimestamp();
                                else
                                    scope.destThumbnails[x] = scope.model.destinationVideoFeed[x].thumbnailUrl;
                            }
                            else
                                scope.destThumbnails[x] = PipeDirective.THUMBNAIL_FAIL_IMG;
                        }
                    }
                };

                scope.videofeedTimer = $interval(() => {
                    scope.loadVideoFeed();
                }, this.VIDEOFEED_TIMER_MS + Common.Utils.randomNumber(1000));

                scope.$on('$destroy', () => {
                    if (scope.thumbnailTimer) {
                        $interval.cancel(scope.thumbnailTimer);
                    }

                    if (scope.videofeedTimer) {
                        $interval.cancel(scope.videofeedTimer);
                    }
                });

                scope.showSourceVideoPrompt = (): void => {
                    scope.showVideoPrompt(scope.model.source, scope.model.sourceVideoFeed);
                };

                scope.showDestVideoPrompt = (index: number): void => {
                    scope.showVideoPrompt(scope.model.destinations[index].destination, scope.model.destinationVideoFeed[index]);
                };

                scope.showVideoPrompt = (blockId: string, videoFeed: Models.IVideoFeed): void => {
                    scope.allowStreamPlay = userService.getCurrentUser().authorities.some((auth: Models.IAuthority) => {
                        return auth.authority === 'ROLE_ADMIN';
                    });
                    if (videoFeed !== undefined && videoFeed.videoUrl !== '') {
                        if (scope.allowStreamPlay) {
                            modalService
                            .showModal({
                                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                                controller: Application.Controllers.ConfirmModalController.$name,
                                inputs: {
                                    title: 'Stream play',
                                    description: 'Playing the stream could affect the ongoing transmission. Do you want to continue?',
                                    name: '',
                                    type: 'warning',
                                },
                            })
                            .then((modal: ngModal.IModalObject) => {
                                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID, 
                                    {bgclose: false, modal: false, keyboard: false});
                                modalElem.show();
                                modal.close.then((result: Object) => {
                                    modalElem.hide();
                                    if (result) {
                                        // notifies the backend
                                        videoFeedService.notifyVideoPlayAttemptByBlockId(blockId, videoFeed);
                                        scope.showVideo(blockId, videoFeed);
                                    }
                                });
                            });

                        } else {
                            modalService.showModal({
                                templateUrl: Application.Controllers.InfoModalController.templateURL,
                                controller: Application.Controllers.InfoModalController.$name,
                                inputs: {
                                    title: 'Stream play',
                                    description: "Playing the stream is only allowed for Administrator profiles",
                                },
                            }).then((modal: ngModal.IModalObject) => {
                                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.InfoModalController.ID,
                                                                    {bgclose: false, modal: false, keyboard: false});
                                modalElem.show();
                                modal.close.then((result: Object) => {
                                    modalElem.hide();
                                });
                            });
                        }
                    } else {
                        // Common.Utils.alertOnInfo("No stream URL available");
                        modalService.showModal({
                                templateUrl: Application.Controllers.InfoModalController.templateURL,
                                controller: Application.Controllers.InfoModalController.$name,
                                inputs: {
                                    title: 'Stream play',
                                    description: "There's no stream URL available.",
                                },
                            }).then((modal: ngModal.IModalObject) => {
                                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.InfoModalController.ID,
                                                                    {bgclose: false, modal: false, keyboard: false});
                                modalElem.show();
                                modal.close.then((result: Object) => {
                                    modalElem.hide();
                                });
                            });
                    }
                };

                scope.showVideo = function(blockId: string, videoFeed: Models.IVideoFeed): void {
                        modalService
                            .showModal({
                                templateUrl: Application.Controllers.VideoPlayerModalController.templateUrl,
                                controller: Application.Controllers.VideoPlayerModalController.$name,
                                inputs: {
                                    streamURL: videoFeed.videoUrl,
                                    live: true,
                                    blockId: blockId,
                                    videoFeed: videoFeed,
                                },
                            })
                            .then((modal: ngModal.IModalObject) => {
                                let videoPlayerModalElem: UIkit.ModalElement;
                                videoPlayerModalElem = UIkit.modal(Application.Controllers.VideoPlayerModalController.ID,
                                                                {bgclose: false, modal: false, keyboard: false});
                                videoPlayerModalElem.show();
                                modal.close.then(() => {
                                    videoPlayerModalElem.hide();
                                });
                        });
                };
                
                scope.loadVideoFeed(true);
            };
        }

        private showLockedSourceModal(): void {
            this.showLockedModal("One or many destinations on this stream pipe are locked and cannot be removed or paused");
        }

        private showLockedDestinationModal(): void {
            this.showLockedModal("The destination of this stream pipe is locked and cannot be removed or paused");
        }

        private showLockedModal(message: string): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.InfoModalController.templateURL,
                controller: Application.Controllers.InfoModalController.$name,
                inputs: {
                    title: 'Pipe is locked',
                    description: message,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.InfoModalController.ID, 
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();                           
                modal.close.then((result: Object) => {
                    modalElem.hide();
                });
            });
        }

        private containsLockedDestinations(destinations: Models.IDestination[]): boolean {
            for (let dest of destinations) {
                if (dest.locked) {
                    return true;
                }
            }

            return false;
        }

    }
}
